<template>
  <div class="errors-list-dialog-container">
    <!-- HEADER -->
    <CustomDialogHeaderComponent :headerTitle="texts.title" />
    
    <!-- LIST ERRORS -->
    <LfErrorListComponent
      :errors="props.componentProps.errors"
      :description="texts.body"
      :icon="icon" />

    <!-- BUTTONS -->
    <CustomDialogActionButtonsComponent 
      :showSecondaryButton="false" 
      :primaryButtonText="texts.primaryButtonText"
      :mainAction="closeDialog" />
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n-composable'
import CustomDialogActionButtonsComponent from '@/components/Dialog/CustomDialog/CustomDialogActionButtonsComponent.vue'
import CustomDialogHeaderComponent from '@/components/Dialog/CustomDialog/CustomDialogHeaderComponent.vue'
import { ModuleNamespaces } from '@/store/types/storeGlobalTypes'
import store from '@/store/store'
import LfErrorListComponent from '@/components/forms/message/LfErrorListComponent.vue'

const { t } = useI18n()

const props = defineProps<{
  componentProps: { errors: string[], title: string, description: string }
}>()

const texts = {
  title: props.componentProps.title || t('components.dialog.maintenance_errors_list_title_default').toString(),
  body: props.componentProps.description || t('components.dialog.maintenance_errors_list_description_default').toString(),
  primaryButtonText: t('action_buttons.accept').toString()
}

const icon = computed(() => {
  return require('@/assets/images/svg/Track-Right.svg')
})

const closeDialog = () => {
  store.dispatch(`${ModuleNamespaces.DIALOG}/closeCustomDialog`)
}

</script>

<style scoped lang="scss">
.errors-list-dialog-container {
   width: 100%;
}
</style>
